<template lang="html">
<div>
     <div class="c-body">
         <div class="list-ttl">专辑曲目列表</div>
         <div class="album-list">
              <div :class="['list-item',{'act':nowPlay==item.id}]" v-for="(item,index) in listDat" :key='index' @click="goInner(item)">
                  <div class="item-x">{{item.side}}{{item.code}}</div>
                  <div class="item-content">
                       <div>
                           <div class="song-name">{{item.firstTitle}}</div>
                           <div class="song-text ellipsis">
                                {{item.info | getClassify}} / {{item.info | getAuthors}}
                           </div>
                       </div>
                  </div>
                  <div class="item-icons">
                        <van-icon class="icon" class-prefix="iconfont" name="play2" />
                  </div>
              </div>
         </div>
     </div>
</div>
</template>

<script>
export default {
    props:['listDat','albumId'],
    filters:{
        getClassify:function(e){
            let classArr = JSON.parse(e)['音乐分类'].split(",");
            if(classArr.length > 0){
                return classArr[classArr.length - 1];
            }else{
                return '/';
            }

        },
        getAuthors:function(e){
            let authors = JSON.parse(e)['演唱'] || JSON.parse(e)['演奏'];
            if(authors!==undefined){
                return authors[0]['显示'];
            }

        }
    },
    data(){
        return{
             nowPlay:''
        }
    },
    methods:{
        goInner:function(e){
            this.$emit('goFreash',e.id);
        }
    },
    mounted:function(){
        window.console.log(this.listDat);
        this.nowPlay = this.$route.query.icd;
    }
}
</script>

<style lang="css" scoped>

.list-ttl{
    font-weight: bold;
    margin: 0 10px;
    margin-top: 6px;
}

.list-item{
    display: flex;
    height: 72px;
    align-items: center;
}

.item-x{
    width: 36px;
    flex-shrink: 0;
    margin-left: 12px;
}

.song-text{
    position: relative;
    width: 285px;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0.72px;
    margin-top: 2px;
    margin-left: -3px;
}

.item-content{
    flex-grow: 1;
    height: 72px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef;
}

.item-icons{
    height: 72px;
    width: 45px;
    text-align: center;
    line-height: 72px;
    flex-shrink: 0;
    border-bottom: 1px solid #efefef;
}

.item-icons .icon{
  font-size: 24px;
  color: #999999;
}

.list-item.act{
    color: #af2d2d;
}

.list-item.act .song-text{
    color: #af2d2d;
}

.list-item.act .icon{
    color: #af2d2d;
}

</style>
